import regexp from 'shared/constants/regexp';
import { all } from 'shared/constants/codeOperators';
import { Banners } from './googletag';
import Translit from './translit';
import TextErrField from './textErrField';
import { sity } from './subjectiveText/allText';
import SubjectiveText from './subjectiveText';
import * as Firms from './firms';
import { ignoreTopBanner as ignorTopBannerMod } from './googletag/store';
import targetingMod from './targeting';
import * as dataLayerMod from './dataLayer';

export const Googletag = Banners;
export const firms = Firms;
export const ignoreTopBanner = ignorTopBannerMod;
export const translit = Translit;
export const targeting = targetingMod;
export const subjectiveText = SubjectiveText;
export const stateDataLayer = dataLayerMod;
export const notEmptyField = (val, text) => (!val ? 'Обязательное поле' : text);
export const textErrField = TextErrField;
export const urlReplace = a =>
  String(a)
    .replace(/\(/g, '&#40')
    .replace(/\)/g, '&#41')
    .replace(/'/g, '');
export const urlReplaceSlash = a => String(a).replace(/\/\/|\/\/\//g, '/');
// eslint-disable-next-line prettier/prettier
export const replaceToUpperCase = a => (a === '' ? '' : `${a[0].toUpperCase()}${a.substr(1).toLowerCase()}`);
export const replaceToLowerCase = a => (a === '' ? '' : a.toLowerCase());
export const pluralize = (text, count, endings) => {
  if (typeof text !== 'string' || typeof count !== 'number' || !Array.isArray(endings)) {
    return text;
  }
  if ([11, 12, 13, 14].includes(count % 100)) {
    return `${text}${endings[0]}`;
  } else if (count % 10 === 1) {
    return `${text}${endings[1]}`;
  } else if ([2, 3, 4].includes(count % 10)) {
    return `${text}${endings[2]}`;
  }

  return `${text}${endings[0]}`;
};
export const replaceSpace = a => a.replace(/\s{1,5}/g, ' ');
export const normalizeLink = (link, { url, defaul }) => {
  const strUrl = url.indexOf(`/${link}`);
  if (strUrl !== -1) {
    return url.slice(0, strUrl + link.length + 1);
  }
  return defaul;
};
export const phoneNormalize = data => {
  if (typeof data !== 'string') {
    return data;
  }
  let phone = data.replace(/\s/g, '');
  // eslint-disable-next-line no-useless-escape
  if (regexp.phone.test(phone)) phone = String(phone).replace(/[\(\)\s-\+-\-\,\s]{0,}/g, '');
  if (new RegExp(`^(${all})[0-9]{7}$`).test(phone)) phone = `+38${phone}`;
  if (new RegExp(`^8(${all})[0-9]{7}$`).test(phone)) phone = `+3${phone}`;
  if (new RegExp(`^38(${all})[0-9]{7}$`).test(phone)) phone = `+${phone}`;
  if (new RegExp(`^[0-9]{12,}$`).test(phone)) phone = `+${phone}`;
  return phone;
};
export const cityLocale = (data, locale, rolle) => {
  if (data && rolle && sity[data] && sity[data][locale] && sity[data][locale][rolle]) {
    return sity[data][locale][rolle];
  }
  return data;
};
export const transformTrim = value => {
  if (typeof value === 'string') {
    return value.trim().replace(/\s/g, '');
  }
  if (typeof value === 'object') {
    const obj = {};
    Object.keys(value).forEach(a => {
      if (typeof value[a] === 'string') {
        obj[a] = value[a].trim();
      }
      obj[a] = value[a];
    });

    return obj;
  }
  return value;
};

export const replaceTransport = transport => {
  if (transport === 'Грузовые') return 'Грузовики';
  else if (transport === 'Вантажні') return 'Вантажівки';
  else if (transport === 'Спецтехника') return 'Спецтехнику';
  else if (transport === 'Спецтехніка') return 'Спецтехніку';
  else if (transport === 'легковые') return 'Легковые авто';
  else if (transport === 'легкові') return 'Легкові авто';
  return transport;
};

export const buildInGenitiveCityHeader = genitiveCity => {
  let inSlug = 'в';

  if (genitiveCity === 'Львове') inSlug = 'во';
  else if (genitiveCity === 'Львові' || genitiveCity === 'Вінниці' || genitiveCity === 'Луцьку')
    inSlug = 'у';
  return `${inSlug} ${genitiveCity}`;
};

export const buildDriveValue = (driveSelected, t) => {
  let drive = driveSelected ? `${driveSelected} ${t('привод')}` : '';

  if (driveSelected === 'Повний що підключається') drive = 'Повний привід що підключається';
  return drive;
};

export const camelCaseToUpperCase = link =>
  link
    .split('_')
    .map((string, index) => {
      if (index > 0) return replaceToUpperCase(string);
      return string;
    })
    .join('');



// WEBPACK FOOTER //
// ./src/shared/modules/index.js